import { IIntakePetSection, IModel, IntakePetSection, IPhotoModel, IReservationModel, Model, PhotoModel, ReservationModel } from ".";

export interface IIntakePetModel extends IModel {
    intakePetId: number;
    intakeId: number;
    speciesId: number | undefined;
    reservationId: number | undefined;
    reservation: IReservationModel | undefined;
    petId: number | undefined;
    name: string;
    genderId: number | undefined;
    breedId: number | undefined;
    petColorId: number | undefined;
    photoId: number | undefined;
    photo?: IPhotoModel | undefined;
    birthDate?: Date;
    isMixedBreed?: boolean;
    // Friendly birthdate needs to be computed
    notificationSentDate?: Date;
    responseCompleteDate?: Date;
    responseLinkSource: string;
    expectedFullVisitDate?: Date;
    expectedVisitDate: string; // formatted string from the server
    expectedVisitTime: string; // formatted string from the server
    sections: IIntakePetSection[];
}

export class IntakePetModel extends Model implements Record<keyof IIntakePetModel, any> {
    intakePetId: number;
    intakeId: number;
    speciesId: number | undefined;
    reservationId: number | undefined;
    reservation: ReservationModel | undefined;
    petId: number | undefined;
    name: string;
    genderId: number | undefined;
    breedId: number | undefined;
    petColorId: number | undefined;
    photoId: number | undefined;
    photo: IPhotoModel | undefined;
    birthDate: Date | undefined;
    isMixedBreed: boolean | undefined;
    notificationSentDate: Date | undefined;
    responseCompleteDate: Date | undefined;
    responseLinkSource: string;
    expectedFullVisitDate: Date | undefined;
    expectedVisitDate: string;
    expectedVisitTime: string;
    sections: IntakePetSection[] = [];

    constructor(params: Partial<IIntakePetModel> = {} as IIntakePetModel) {
        super(params);
        const {
            intakePetId = 0,
            intakeId = 0,
            speciesId = undefined,
            reservationId = undefined,
            petId = undefined,
            name = '',
            genderId = undefined,
            breedId = undefined,
            petColorId = undefined,
            photoId = undefined,
            photo = undefined,
            birthDate = undefined,
            isMixedBreed = undefined,
            notificationSentDate = undefined,
            responseCompleteDate = undefined,
            responseLinkSource = '',
            expectedFullVisitDate = undefined,
            expectedVisitDate = '',
            expectedVisitTime = '',
            sections = [] as Array<IntakePetSection>
        } = params;

        this.intakePetId = intakePetId;
        this.intakeId = intakeId;
        this.speciesId = speciesId;
        this.reservationId = reservationId;
        this.reservation = params.reservation ? new ReservationModel(params.reservation) : undefined;
        this.petId = petId;
        this.name = name;
        this.genderId = genderId;
        this.breedId = breedId;
        this.petColorId = petColorId;
        this.photoId = photoId;
        this.photo = photo ? new PhotoModel(photo) : undefined;
        this.birthDate = (birthDate) ? new Date(birthDate) : undefined;
        this.isMixedBreed = isMixedBreed;
        this.notificationSentDate = notificationSentDate;
        this.responseCompleteDate = responseCompleteDate;
        this.responseLinkSource = responseLinkSource;
        this.expectedFullVisitDate = expectedFullVisitDate ? new Date(expectedFullVisitDate) : undefined;
        this.expectedVisitDate = expectedVisitDate;
        this.expectedVisitTime = expectedVisitTime;
        _.map(sections, (s) => { this.sections.push(new IntakePetSection(s)) });
    }

    /* ---------- */
    displayThumbnailUrlFixedByWidthAndHeight = (width?: number, height?: number, mode?: string): string | undefined => {
        height = height || 65;
        width = width || 65;
        mode = mode || 'crop';

        mode = '&mode=' + mode;

        if (this.photo)
            return this.photo.processedPhotoBaseUrl.includes("data:") ?
                this.photo.processedPhotoBaseUrl :
                this.photo.processedPhotoBaseUrl + `?width=${60}&height=${60}${mode}`;
        else
            return undefined;
    }
}
